import React from 'react';

const Error = () => {
  return <div> 404 ERROR! PAGE NOT FOUND </div>;
};

export default Error;
